import { useMediaQuery } from 'react-responsive';

export const useIsDesktop = () => useMediaQuery({ minWidth: 1024 });

export const useIsNotDesktop = () => useMediaQuery({ maxWidth: 1023 });

export const useIsTablet = () =>
  useMediaQuery({
    minWidth: 768,
    maxWidth: 1023,
  });

export const useIsMobile = () => useMediaQuery({ maxWidth: 767 });

export const useIsNotMobile = () => useMediaQuery({ minWidth: 768 });
